@if (hasRole()) {
  <button class="shortcut-menu__button" (click)="startSelfService()" [class.button--disabled]="selfServiceDisabled()">
    @if (isAuthenticatedForSelfService()) {
      <svg-icon src="assets/images/icons/cog-check.svg" class="shortcut-menu__button-icon--green"></svg-icon>
      <span class="shortcut-menu__started">{{ "ShortcutMenu.SelfServiceStarted" | translate }}</span>
      <div class="shortcut-menu__green-text"><!-- 19:40 -->{{ selfServiceTokenValidFor() | formatduration }}</div>
    } @else {
      <svg-icon src="assets/images/icons/cog.svg"></svg-icon>
      <span>{{ "ShortcutMenu.SelfService" | translate }}</span>
    }
  </button>
} @else {
  <button
    class="shortcut-menu__button"
    (click)="showWrongRoleMessage()"
    [class.button--disabled]="selfServiceDisabled()"
  >
    <svg-icon src="assets/images/icons/cog.svg"></svg-icon>
    <span>{{ "ShortcutMenu.SelfService" | translate }}</span>
  </button>
}
